export default __webpack_public_path__ + "static/media/signup_banner_Cn.5d3fedbb.jpg";